import { Component, ViewEncapsulation } from '@angular/core';
import { DispatchesService } from '@app/cp/shared/services/dispatches.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_DispatchEquipmentSvcdBus } from '@app/cp/shared/models/v_DispatchEquipmentSvcdBus';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';

@Component({
    selector: 'jobs-equip-svcd',
    templateUrl: './jobs-equip-svcd.component.html',
    styleUrls: ['./jobs-equip-svcd.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class JobsEquipSvcdComponent extends BaseGridUIComponent<v_DispatchEquipmentSvcdBus, null, DispatchesService>  {

  constructor(globals: GlobalsService, svc_data: DispatchesService) {
    super(globals);
    this.svc_data = svc_data;
  }
}
